export enum EAgroservicesApiUrl {
  AGROSERVICE_PRODUCTS = '/api/agroservices/products',
  AGROSERVICE_REQUESTS = '/api/agroservices/requests',
}
